"use client";

import { ReactNode } from "react";
import { useSidebarContext } from "./sidebar-context";

type Props = { children: ReactNode };

/**
 * Pinned bottom slot for a `Sidebar` — e.g. `<SidebarFooter><SidebarAccountMenu
 * .../></SidebarFooter>`, or a plain list of `SidebarNavItem`s. Hidden on the
 * mobile fixed bar and the desktop collapsed rail (there's no room for rich
 * footer content in either).
 */
export const SidebarFooter = ({ children }: Props) => {
  const { slot, isExpanded } = useSidebarContext();

  if (slot === "mobile-bar") return null;
  if (slot === "desktop" && !isExpanded) return null;

  return <div className="px-1 pb-1">{children}</div>;
};
